module.exports = __webpack_public_path__ + "img/full_map.72840557.png";